import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromApp from "../../../../store/app.reducer";
import * as selectors from "../../../../store/app.selectors";
import * as _ from "lodash";
import {
  AlertController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import * as CartActions from "../../../../cart/store/cart.actions";
import { distinctUntilChanged, first } from "rxjs/operators";
import { Subscription } from "rxjs";
import { ProductDetailsComponent } from "src/app/product-details/product-details.component";
import moment from "moment";
import { ProductValidDeliveryAreasPopupComponent } from "src/app/popups/product-valid-delivery-areas-popup/product-valid-delivery-areas-popup.component";
import { ProductDetailsOperationsService } from "src/app/product-details/product-details-operations.service";
import * as CartActiveCouponsActions from "../../cart-active-coupons/store/cartActiveCoupons.actions";
import {
  QUANTITY_DECIMALS,
  roundQuantity,
} from "../../../../services/quantity-decimals";

@Component({
  selector: "app-cart-list-product-item",
  templateUrl: "./cart-list-product-item.component.html",
  styleUrls: ["./cart-list-product-item.component.scss"],
})
export class CartListProductItemComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() cartProduct;
  @Input() onlyAvailableForPreorderProductsById: any;
  @Input() selectedAddress: any;
  public finalPriceLoading: boolean;
  public showProductItemDetails: boolean = false;
  public orderPickup: any;
  public dineIn: any;
  public deleteAlertConfirm: any;
  public groupApp: any;
  public productPointsSystemException: boolean;
  public productPointSystemWeight: number = 1;
  public store_info: any;
  public selectedDineInTable: any;
  public doNotShowNeedsEditMessage: boolean = false;
  selectedPreorderDate;
  preorderDayAfterToday;
  cartPrices;

  private windowDimensions;
  private allCartProducts: any;
  private errorToast: any;
  private productDetailsModal: any;
  private productValidDeliveryAreasModal: any;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<fromApp.AppState>,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
    private toastCtrl: ToastController,
    private productDetailsOperationsService: ProductDetailsOperationsService,
    private modalController: ModalController
  ) {}

  hideQuantityFromChoicesMultiplier(cartProduct) {
    if (
      !cartProduct ||
      !cartProduct.quantityOnlyFromChoices ||
      !cartProduct.options ||
      !cartProduct.options.length
    ) {
      return false;
    }

    const eligibleChoices: any[] = [];
    _.each(cartProduct.options, (option: any) => {
      if (
        option &&
        option.productQuantityChangeChoices &&
        option.quantityInChoices &&
        option.choices &&
        option.choices.length
      ) {
        _.each(option.choices, (choice: any) => {
          const price = choice ? choice.price : null;
          const isFree =
            price == null ||
            price === 0 ||
            price === "0" ||
            price === "0.00";
          if (choice && choice.is_preselected && isFree) {
            eligibleChoices.push({ option, choice });
          }
        });
      }
    });

    if (eligibleChoices.length !== 1) {
      return false;
    }

    const only = eligibleChoices[0];
    const multiplier = only && only.choice ? only.choice.productQuantityMultiplier : null;
    return (
      only.option &&
      only.option.choices &&
      only.option.choices.length === 1 &&
      typeof multiplier === "number" &&
      multiplier > 1
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkProductIfBundleOpenChoices();
  }

  ngOnInit() {
    this.checkProductIfBundleOpenChoices();
    this.subscriptions.push(
      this.store
        .select("deliveryMethodAddress")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
            this.orderPickup = _.cloneDeep(state.orderPickup);
          }

          if (state && !_.isEqual(this.dineIn, state.dineIn)) {
            this.dineIn = _.cloneDeep(state.dineIn);
          }

          if (
            state &&
            !_.isEqual(this.selectedDineInTable, state.selectedDineInTable)
          ) {
            this.selectedDineInTable = _.cloneDeep(state.selectedDineInTable);
          }

          if (
            state &&
            !_.isEqual(this.selectedPreorderDate, state.selectedPreorderDate)
          ) {
            this.selectedPreorderDate = _.cloneDeep(state.selectedPreorderDate);
            this.preorderDayAfterToday = this.checkPreorderDateIsAfterToday();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cart")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(
              this.onlyAvailableForPreorderProductsById,
              state.onlyAvailableForPreorderCartProductsById
            )
          ) {
            this.onlyAvailableForPreorderProductsById = _.cloneDeep(
              state.onlyAvailableForPreorderCartProductsById
            );
          }

          if (
            state &&
            state.products &&
            !_.isEqual(this.allCartProducts, state.products)
          ) {
            this.allCartProducts = _.cloneDeep(state.products);

            this.store
              .select("deliveryMethodAddress")
              .pipe(first())
              .subscribe((state) => {
                this.checkForHideNeedsEditDebounced(
                  state.orderPickup,
                  state.dineIn
                );
              })
              .unsubscribe();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("disableFinalPrice")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(this.finalPriceLoading, state.disableFinalPrice)
          ) {
            this.finalPriceLoading = _.cloneDeep(state.disableFinalPrice);
          }
        })
    );

    // if (this.cartProduct) {
    //   this.cartProduct.options.forEach((opt) => {
    //     //console.log(opt);
    //   });
    // }
    // this.subscription2 = this.store
    //   .select("deliveryMethodAddress")
    //   .subscribe((state) => {
    //     if (state && _.isEqual(state.orderPickup, this.orderPickup)) {
    //       this.orderPickup = _.cloneDeep(state.orderPickup);
    //     }
    //   });

    this.subscriptions.push(
      this.store
        .select("groupApp")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.groupApp &&
            !_.isEqual(state.groupApp, this.groupApp)
          ) {
            this.groupApp = _.cloneDeep(state.groupApp);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())
        .subscribe((store_info) => {
          if (store_info && !_.isEqual(store_info, this.store_info)) {
            this.store_info = _.cloneDeep(store_info);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("windowInfo")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(state.windowDimensions, this.windowDimensions)
          ) {
            this.windowDimensions = _.cloneDeep(state.windowDimensions);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartPrices")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(state.cartPrices, this.cartPrices)) {
            this.cartPrices = _.cloneDeep(state.cartPrices);
          }
        })
    );
  }

  checkProductIfBundleOpenChoices() {
    if (this.cartProduct && this.cartProduct.options) {
      _.each(this.cartProduct.options, (opt) => {
        if (this.showProductItemDetails) {
          return false;
        }
        if (opt.bundle && opt.choices) {
          _.each(opt.choices, (ch) => {
            if (ch.bundle && ch.is_preselected) {
              this.showProductItemDetails = true;
              return false;
            }
          });
        }
      });
    }
  }

  checkPreorderDateIsAfterToday() {
    if (
      this.selectedPreorderDate &&
      this.selectedPreorderDate.date &&
      this.selectedPreorderDate.hour
    ) {
      const preorderDate = moment(
        `${this.selectedPreorderDate.date} ${this.selectedPreorderDate.hour}`,
        "DD-MM-YYYY HH:mm"
      );

      const tomorrowDate = moment()
        .add(1, "day")
        .set("hour", 0)
        .set("minutes", 0);

      if (preorderDate.isAfter(tomorrowDate)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  calculateProductPointSystemAttributes() {}

  // calculatePrice() {
  //   let price = parseFloat(this.cartProduct.price);
  //   let quantity = parseFloat(this.cartProduct.quantity);
  //   return (price * quantity).toFixed(2) + "€";
  // }

  changeProductQuantity(ev) {
    if (ev === "increase") {
      this.increaseQuantity();
    } else if (ev === "decrease") {
      this.decreaseQuantity();
    }
  }

  presentAlertConfirm(cartProductItem) {
    if (!this.deleteAlertConfirm) {
      this.deleteAlertConfirm = true;
      this.showAlertConfirm(cartProductItem);
    }
  }

  async showAlertConfirm(cartProductItem) {
    this.deleteAlertConfirm = await this.alertCtrl.create({
      cssClass: "my-custom-class",
      header: this.translateService.instant(
        "cart.cart-components.cart-list.cart-list-product-item.delete"
      ),
      message: this.translateService.instant(
        "cart.cart-components.cart-list.cart-list-product-item.do-you-want-to-delete-product-from-cart"
      ),
      buttons: [
        {
          text: this.translateService.instant(
            "cart.cart-components.cart-list.cart-list-product-item.cancel"
          ),
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: this.translateService.instant(
            "cart.cart-components.cart-list.cart-list-product-item.delete"
          ),
          handler: () => {
            this.deleteCartItem(cartProductItem);
          },
        },
      ],
    });

    await this.deleteAlertConfirm.present();
    this.deleteAlertConfirm.onDidDismiss().then(() => {
      this.deleteAlertConfirm = false;
    });
  }

  showProductDetailsModal(product) {
    const detailsCssClass =
      this.productDetailsOperationsService.getProductDetailsModalCssClass(
        _.cloneDeep(product),
        _.cloneDeep(this.windowDimensions)
      );
    console.log("detals css", detailsCssClass, product);
    if (!this.productDetailsModal) {
      this.productDetailsModal = true;
      this.presentProductDetailsModal(product, detailsCssClass);
    }
  }

  async presentProductDetailsModal(product, cssClass) {
    let product_id: string;
    let cart_id: string;
    if (product && product.product_id) {
      product_id = product.product_id;
    }

    if (product && product.cart_id) {
      cart_id = product.cart_id;
    }

    this.productDetailsModal = await this.modalController.create({
      component: ProductDetailsComponent,
      cssClass: cssClass,
      animated: true,
      componentProps: {
        product_id: product.product_id,
        cart_id: product.cart_id,
      },
      backdropDismiss: false,
    });

    await this.productDetailsModal.present();
    this.productDetailsModal.onDidDismiss().then(() => {
      this.productDetailsModal = null;
    });
  }

  productHaveDetails(prd) {
    let showProducts = false;

    _.each(prd.options, (option) => {
      if (
        option &&
        option.option_id &&
        (!option.dependenciesVariable ||
          option.dependenciesVariable.length === 0 ||
          (option.dependenciesVariable.length > 0 && option.showDependent))
      ) {
        if (option.type !== "field") {
          if (
            !(
              option.choices &&
              !option.reverseChoices &&
              this.choicesIsPreselected(option.choices).length === 0
            ) ||
            (option.is_require && option.availableTotal)
          ) {
            if (
              !option.doNotPrint ||
              (option.parent_free && option.option_parent_total_price === 0)
            ) {
              //console.log("retuntrue");
              showProducts = true;
            } else {
              //console.log("retunfalse");
            }
          }
          if (
            option.type === "checkbox" &&
            option.reverseChoices &&
            option.choicesComment
          ) {
            //console.log("retuntrue");
            showProducts = true;
          }
          _.each(option.choices, (choice) => {
            if (
              !choice.doNotPrint &&
              (option.type !== "checkbox" ||
                !option.reverseChoices ||
                (!option.choicesComment && !option.reverseChoices))
            ) {
              showProducts = true;
            }

            if (choice.choicePriceComment) {
              showProducts = true;
            } else {
              if (choice.price) {
                showProducts = true;
              }
            }
          });
        } else {
          if (option.text) {
            //console.log("retuntrue");
            showProducts = true;
          } else {
            // console.log("retunfalse");
          }
        }
      } else {
        // console.log("retunfalse");
      }
    });
    return showProducts;
  }

  showProductValidDeliveryAreasInfoModal() {
    if (!this.productValidDeliveryAreasModal) {
      this.presentProductValidDeliveryAreasModal();
    }
  }

  async presentProductValidDeliveryAreasModal() {
    this.productValidDeliveryAreasModal = await this.modalController.create({
      component: ProductValidDeliveryAreasPopupComponent,
      cssClass: "productValidDeliveryAreasPopup",
      animated: true,
      componentProps: {
        notValidAddress: this.selectedAddress,
        cartProduct: this.cartProduct,
      },
      backdropDismiss: false,
    });

    await this.productValidDeliveryAreasModal.present();
    this.productValidDeliveryAreasModal.onDidDismiss().then(() => {
      this.productValidDeliveryAreasModal = null;
    });
  }

  choicesIsPreselected(choices) {
    let preselectedArray = [];
    choices.forEach((choice) => {
      if (choice && choice.is_preselected) {
        preselectedArray.push(choice);
      }
    });

    return preselectedArray;
  }

  deleteCartItem(product) {
    this.store
      .select("cartActiveCoupons")
      .pipe(first())
      .subscribe((state) => {
        if (state && state.activeCoupons && state.activeCoupons.length) {
          const cartCoupons = _.cloneDeep(state.activeCoupons);
          _.each(_.cloneDeep(cartCoupons), (coupon, index) => {
            if (
              coupon.couponCheckbox &&
              !coupon.discountType &&
              coupon.product_id &&
              this.cartProduct.product_id === coupon.product_id &&
              (this.cartProduct.product_coupon_timestamp === coupon.timestamp ||
                this.cartProduct.gift_product_coupon_timestamp ===
                  coupon.timestamp)
            ) {
              cartCoupons[index].couponCheckbox = false;
            }
          });

          this.store.dispatch(
            new CartActiveCouponsActions.SetActiveCoupons(
              _.cloneDeep(cartCoupons)
            )
          );
        }

        if (navigator.cookieEnabled) {
          let cart = JSON.parse(window.localStorage.getItem("cart"));

          if (cart) {
            let indexOfProduct = _.findIndex(cart, {
              cart_id: product.cart_id,
            });

            if (indexOfProduct !== -1) {
              cart.splice(indexOfProduct, 1);

              window.localStorage.removeItem("cart");

              window.localStorage.setItem("cart", JSON.stringify(cart));
            }
          }
        }
        this.store.dispatch(new CartActions.DeleteCartProductItem(product));
      })
      .unsubscribe();
  }

  validatedMaxQuantityInCart(product) {
    return new Promise((resolve) => {
      this.store
        .select("cart")
        .pipe(first())
        .subscribe((state) => {
          const cartProducts = _.cloneDeep(state.products);

          let valid = true;
          let productQuantityInCart = 0;
          if (cartProducts && cartProducts.length) {
            _.each(cartProducts, (cartProduct) => {
              if (cartProduct.product_id === product.product_id) {
                productQuantityInCart =
                  cartProduct.quantity + productQuantityInCart;
              }
            });
          }

          if (product.cart_id) {
            const cartProduct = _.find(cartProducts, {
              cart_id: product.cart_id,
            });

            if (!_.isEmpty(cartProduct)) {
              productQuantityInCart =
                productQuantityInCart - cartProduct.quantity;
            }
          }

          if (
            roundQuantity(productQuantityInCart + product.quantity) >
            product.maxQuantityInCart
          ) {
            valid = false;
          }

          resolve(valid);
        })
        .unsubscribe();
    });
  }

  async increaseQuantity() {
    if (this.cartProduct && this.cartProduct.quantity < 50) {
      let tempProduct = _.cloneDeep(this.cartProduct);
      if (
        this.cartProduct.enable_quantity_step &&
        this.cartProduct.quantity_step &&
        !this.cartProduct.max_quantity &&
        parseFloat(
          parseFloat(
            _.cloneDeep(
              tempProduct.quantity + tempProduct.quantity_step
            ).toString()
          ).toFixed(QUANTITY_DECIMALS)
        ) < 50
      ) {
        tempProduct.quantity = parseFloat(
          parseFloat(
            _.cloneDeep(
              tempProduct.quantity + tempProduct.quantity_step
            ).toString()
          ).toFixed(QUANTITY_DECIMALS)
        );
      } else if (
        this.cartProduct.enable_quantity_step &&
        this.cartProduct.quantity_step &&
        this.cartProduct.max_quantity &&
        parseFloat(
          parseFloat(
            _.cloneDeep(
              tempProduct.quantity + tempProduct.quantity_step
            ).toString()
          ).toFixed(QUANTITY_DECIMALS)
        ) < this.cartProduct.max_quantity
      ) {
        tempProduct.quantity = parseFloat(
          parseFloat(
            _.cloneDeep(
              tempProduct.quantity + tempProduct.quantity_step
            ).toString()
          ).toFixed(QUANTITY_DECIMALS)
        );
      } else if (
        !this.cartProduct.enable_quantity_step ||
        !this.cartProduct.quantity_step
      ) {
        tempProduct.quantity++;
      }

      const validatedMaxQuantityInCartResp =
        await this.validatedMaxQuantityInCart(tempProduct);

      if (
        this.cartProduct &&
        this.cartProduct.maxQuantityInCart &&
        !validatedMaxQuantityInCartResp
      ) {
        this.presentErrorToast(
          this.translateService.instant(
            "product-details.you-have-already-the-max-quantity"
          ) +
            " " +
            this.cartProduct.maxQuantityInCart
        );
        return;
      }

      this.store.dispatch(
        new CartActions.AddUpdateCartProductItem(_.cloneDeep(tempProduct))
      );
    }
  }

  async decreaseQuantity() {
    let newCartProduct = _.cloneDeep(this.cartProduct);

    if (
      newCartProduct &&
      newCartProduct.quantity > 0 &&
      newCartProduct.enable_quantity_step &&
      newCartProduct.quantity_step &&
      (newCartProduct.min_quantity
        ? parseFloat(
            parseFloat(
              _.cloneDeep(
                newCartProduct.quantity - newCartProduct.quantity_step
              ).toString()
            ).toFixed(QUANTITY_DECIMALS)
          ) >= newCartProduct.min_quantity
        : parseFloat(
            parseFloat(
              _.cloneDeep(
                newCartProduct.quantity - newCartProduct.quantity_step
              ).toString()
            ).toFixed(QUANTITY_DECIMALS)
          ) > 0)
    ) {
      newCartProduct.quantity = parseFloat(
        parseFloat(
          _.cloneDeep(
            newCartProduct.quantity - newCartProduct.quantity_step
          ).toString()
        ).toFixed(QUANTITY_DECIMALS)
      );

      this.store.dispatch(
        new CartActions.AddUpdateCartProductItem(_.cloneDeep(newCartProduct))
      );
    } else if (
      newCartProduct &&
      newCartProduct.quantity > 1 &&
      (!newCartProduct.enable_quantity_step || !newCartProduct.quantity_step)
    ) {
      newCartProduct.quantity--;
      this.store.dispatch(
        new CartActions.AddUpdateCartProductItem(newCartProduct)
      );
    } else if (
      (newCartProduct &&
        newCartProduct.quantity === 1 &&
        (!newCartProduct.enable_quantity_step ||
          !newCartProduct.quantity_step)) ||
      (newCartProduct &&
        newCartProduct.enable_quantity_step &&
        newCartProduct.quantity_step &&
        newCartProduct.quantity - newCartProduct.quantity_step <= 0)
    ) {
      const alert = await this.alertCtrl.create({
        header: this.translateService.instant("alert"),
        message: this.translateService.instant(
          "product-details.do-you-want-to-remove-product-from-cart"
        ),
        buttons: [
          {
            text: this.translateService.instant("no"),
            role: "cancel",
            handler: () => {
              console.log("canceled");
            },
          },
          {
            text: this.translateService.instant("yes"),
            handler: () => {
              this.deleteCartItem(newCartProduct);
            },
          },
        ],
      });
      await alert.present();
    }
  }

  async presentErrorToast(errorMessage) {
    this.errorToast = await this.toastCtrl.create({
      message: errorMessage,
      position: "middle",
      duration: 3000,
      color: "danger",
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",
          handler: () => {
            console.log("Toast Closed");
          },
        },
      ],
    });
    this.errorToast.present();

    this.errorToast.onDidDismiss().then(() => {
      this.errorToast = null;
    });
  }

  private checkForHideNeedsEditDebounced = _.debounce((orderPickup, dineIn) => {
    this.checkForHideNeedsEdit(orderPickup, dineIn);
  }, 200);

  checkForHideNeedsEdit(orderPickup, dineIn) {
    //this function checking if the product is only delivery, dine in,... etc and hiding needs edit message because we display a badge

    if (
      (this.cartProduct &&
        this.cartProduct.product_categories_availability_check &&
        this.cartProduct.availableTotal &&
        this.cartProduct.activeTotal &&
        this.cartProduct.pickup &&
        !this.cartProduct.delivery &&
        !this.cartProduct.dinein &&
        orderPickup) ||
      (this.cartProduct &&
        this.cartProduct.product_categories_availability_check &&
        this.cartProduct.availableTotal &&
        this.cartProduct.activeTotal &&
        this.cartProduct.delivery &&
        !this.cartProduct.dinein &&
        !this.cartProduct.pickup &&
        (orderPickup || dineIn)) ||
      (this.cartProduct &&
        this.cartProduct.product_categories_availability_check &&
        this.cartProduct.availableTotal &&
        this.cartProduct.activeTotal &&
        this.cartProduct.dinein &&
        !this.cartProduct.delivery &&
        !this.cartProduct.pickup &&
        !dineIn) ||
      (this.cartProduct &&
        this.cartProduct.product_categories_availability_check &&
        this.cartProduct.availableTotal &&
        this.cartProduct.activeTotal &&
        this.cartProduct.dinein &&
        this.cartProduct.delivery &&
        !this.cartProduct.pickup &&
        orderPickup) ||
      (this.cartProduct &&
        this.cartProduct.product_categories_availability_check &&
        this.cartProduct.availableTotal &&
        this.cartProduct.activeTotal &&
        this.cartProduct.delivery &&
        this.cartProduct.pickup &&
        !this.cartProduct.dinein &&
        dineIn) ||
      (this.cartProduct &&
        this.cartProduct.product_categories_availability_check &&
        this.cartProduct.availableTotal &&
        this.cartProduct.activeTotal &&
        !this.cartProduct.delivery &&
        this.cartProduct.pickup &&
        this.cartProduct.dinein &&
        !orderPickup &&
        !dineIn)
    ) {
      this.doNotShowNeedsEditMessage = true;
    } else {
      this.doNotShowNeedsEditMessage = false;
    }
  }

  ngOnDestroy() {
    if (this.productValidDeliveryAreasModal) {
      this.productValidDeliveryAreasModal.dismiss();
      this.productValidDeliveryAreasModal = null;
    }
    if (this.productDetailsModal) {
      this.productDetailsModal.dismiss();
      this.productDetailsModal = null;
    }

    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
      this.subscriptions = [];
    }
  }
}
